import { EUROPALLET } from "../lib/pricingDefaults";

/** €15 × pallets when europallets are not exchanged; otherwise 0. */
export function calculateEuropalletNonExchangeFee(
  pallets: number,
  exchanged: boolean,
): number {
  if (exchanged || pallets <= 0) return 0;
  return Number((pallets * EUROPALLET.FEE_PER_PALLET).toFixed(2));
}

/** Calculator / cost-overview label (includes qty breakdown). */
export function europalletNonExchangeDescription(pallets: number): string {
  return `Europallets niet geruild (€${EUROPALLET.FEE_PER_PALLET.toFixed(2)}/pallet × ${pallets})`;
}

/** Invoice line description — qty × unit price carry the amount. */
export function europalletInvoiceLineDescription(): string {
  return "Europallets niet geruild";
}
